export const CRITERION_RESULT_LABELS = {
	FULFILLED: 'Fulfilled',
	PARTIALLY_FULFILLED: 'Partially fulfilled',
	NOT_FULFILLED: 'Not fulfilled',
	NOT_APPLICABLE: 'Not applicable',
	CANNOT_EVALUATE: 'Cannot evaluate',
};

export const EVALUATION_STATUS_LABELS = {
	COMPLETED: 'Completed',
	PARTIAL: 'Partial',
	NOT_APPLICABLE: 'Not applicable',
	UNRELIABLE: 'Unreliable',
	MANUAL_REVIEW_REQUIRED: 'Manual review required',
	FAILED: 'Analysis failed',
	PENDING: 'Pending',
};

export const ANALYSIS_PATH_LABELS = {
	SALES_SCRIPT: 'Sales script',
	NO_RESPONSE: 'No response',
	SHIFT: 'Shift',
	RESIGNED: 'Resigned',
	INBOUND_CALLBACK_SALES: 'Inbound – callback (sales)',
	INBOUND_OFFER_INQUIRY: 'Inbound – offer inquiry',
	INBOUND_SHIPMENT_STATUS: 'Inbound – shipment status',
	INBOUND_DELIVERY_PROBLEM: 'Inbound – delivery problem',
	INBOUND_CANCELLATION: 'Inbound – cancellation',
	INBOUND_DATA_CHANGE: 'Inbound – data change',
	INBOUND_AFTER_SALES: 'Inbound – after sales',
	INBOUND_UNRELATED: 'Inbound – unrelated',
	INBOUND_UNKNOWN: 'Inbound – unknown reason',
};

export const RESULT_COLORS = {
	FULFILLED: '#2e7d32',
	PARTIALLY_FULFILLED: '#ed6c02',
	NOT_FULFILLED: '#d32f2f',
	NOT_APPLICABLE: '#757575',
	CANNOT_EVALUATE: '#9c27b0',
};

const toUpperKey = (value) => String(value || '').toUpperCase();

export const getResultLabel = (result) =>
	CRITERION_RESULT_LABELS[result] ||
	CRITERION_RESULT_LABELS[toUpperKey(result)] ||
	result ||
	'—';

export const getEvaluationStatusLabel = (status) =>
	EVALUATION_STATUS_LABELS[status] ||
	EVALUATION_STATUS_LABELS[toUpperKey(status)] ||
	status ||
	'—';

export const evaluationStatusColor = (status) => {
	const normalized = toUpperKey(status);

	if (normalized === 'COMPLETED') {
		return '#2e7d32';
	}
	if (normalized === 'PARTIAL' || normalized === 'MANUAL_REVIEW_REQUIRED') {
		return '#ed6c02';
	}
	if (normalized === 'PENDING') {
		return '#4570af';
	}
	if (normalized === 'UNRELIABLE' || normalized === 'NOT_APPLICABLE') {
		return '#757575';
	}
	if (normalized === 'FAILED') {
		return '#d32f2f';
	}
	return '#757575';
};

export const getAnalysisPathLabel = (path) =>
	ANALYSIS_PATH_LABELS[path] ||
	ANALYSIS_PATH_LABELS[toUpperKey(path)] ||
	path ||
	'—';

export const HISTORY_TYPE_LABELS = {
	AI_RESULT: 'AI result',
	MANUAL_ACCEPT: 'Accepted',
	MANUAL_REJECT: 'Rejected',
	MANUAL_CORRECT: 'Corrected',
	FEEDBACK: 'Feedback',
};

export const REVIEW_MODE = Object.freeze({
	ACCEPTED: 'ACCEPTED',
	REJECTED: 'REJECTED',
	CORRECTED: 'CORRECTED',
});

export const REVIEW_MODE_LABELS = {
	[REVIEW_MODE.ACCEPTED]: 'Accept AI score',
	[REVIEW_MODE.REJECTED]: 'Mark as incorrect',
	[REVIEW_MODE.CORRECTED]: 'Correct score',
};

export const MANUAL_REVIEW_STATUS_LABELS = {
	[REVIEW_MODE.ACCEPTED]: 'Accepted',
	[REVIEW_MODE.REJECTED]: 'Incorrect',
	[REVIEW_MODE.CORRECTED]: 'Corrected',
};

export const getReviewModeLabel = (mode) => REVIEW_MODE_LABELS[mode] || '';

export const getManualReviewStatusLabel = (status) =>
	MANUAL_REVIEW_STATUS_LABELS[status] ||
	MANUAL_REVIEW_STATUS_LABELS[toUpperKey(status)] ||
	'—';

export const manualReviewStatusColor = (status) => {
	const normalized = toUpperKey(status);

	if (normalized === REVIEW_MODE.ACCEPTED) {
		return '#2e7d32';
	}
	if (normalized === REVIEW_MODE.REJECTED) {
		return '#d32f2f';
	}
	if (normalized === REVIEW_MODE.CORRECTED) {
		return '#ed6c02';
	}
	return '#757575';
};

export const formatScore = (score) =>
	score === null || score === undefined ? '—' : `${Math.round(score)}%`;

export const formatAnalyzedAt = (date) => {
	if (!date) {
		return '—';
	}
	return new Date(date).toLocaleString('en-GB');
};

export const getHistoryTypeLabel = (type) =>
	HISTORY_TYPE_LABELS[type] ||
	HISTORY_TYPE_LABELS[toUpperKey(type)] ||
	type ||
	'—';

export const getHistoryDetailsText = (entry) => {
	const data = entry?.data || {};
	const type = toUpperKey(entry?.type);

	if (type === 'FEEDBACK') {
		return data.feedback || data.feedback_for_system || '—';
	}

	if (type === 'AI_RESULT') {
		return data.evaluation_status || data.reason || data.status || '—';
	}

	return data.comment || data.status || '—';
};

export const scoreColor = (score) => {
	if (score === null || score === undefined) {
		return '#757575';
	}
	if (score >= 80) {
		return '#2e7d32';
	}
	if (score >= 50) {
		return '#ed6c02';
	}
	return '#d32f2f';
};

export const getResultColor = (result) =>
	RESULT_COLORS[result] || RESULT_COLORS[toUpperKey(result)] || '#757575';
